import { capitalizeRequestMethodOperator, requestValidationOperator, HttpMiddlewareHandler, HttpRequestHandler, } from './lib/operators';
/** @inheritdoc */
export class HttpClientConfigurator {
    /** Named client configurations keyed by client name. */
    _clients = {};
    /**
     * Gets a shallow clone of all named client configurations.
     *
     * @returns A shallow clone of the named client configurations.
     */
    get clients() {
        return { ...this._clients };
    }
    /** Default constructor used when a client configuration does not provide `ctor`. */
    defaultHttpClientCtor;
    /** Default request handler pipeline cloned into each created client instance. */
    defaultHttpRequestHandler = new HttpRequestHandler({
        // convert all request methods to uppercase
        'capitalize-method': capitalizeRequestMethodOperator(),
        // validate the request object
        'request-validation': requestValidationOperator(),
    });
    /** Default middleware chain cloned into each created client instance. */
    defaultHttpMiddlewareHandler = new HttpMiddlewareHandler();
    /**
     * Creates a configurator with the default client constructor.
     * @param client - The default client constructor used when `ctor` is not configured per client.
     */
    constructor(client) {
        this.defaultHttpClientCtor = client;
    }
    /** @inheritdoc */
    hasClient(name) {
        return Object.keys(this._clients).includes(name);
    }
    /** @inheritdoc */
    addMiddleware(middleware) {
        this.defaultHttpMiddlewareHandler.use(middleware);
        return this;
    }
    /** @inheritdoc */
    configureClient(name, args) {
        const argFn = typeof args === 'string' ? { baseUri: args } : args;
        const options = typeof argFn === 'function' ? { onCreate: argFn } : argFn;
        // `options` is `HttpClientOptions<T>` (this call's generic), but `_clients` is keyed by the
        // configurator's own `TClient` — callers are expected to keep the two in sync.
        this._clients[name] = {
            ...this._clients[name],
            ...options,
        };
        return this;
    }
}
export default HttpClientConfigurator;
//# sourceMappingURL=configurator.js.map